/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowRoundSyncForwardIcon32Regular = forwardRef('ArrowRoundSyncForwardIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M14.683 5.08A11 11 0 0 1 25.798 11H21.5a1 1 0 1 0 0 2h6a1.5 1.5 0 0 0 1.5-1.5V5a1 1 0 1 0-2 0v4.072a13 13 0 0 0-23.826 4.81 1 1 0 0 0 1.973.326 11 11 0 0 1 9.536-9.129Z" }),
        React.createElement("path", { d: "M10.51 25.532a11 11 0 0 0 16.35-7.782 1 1 0 0 1 1.974.318A13 13 0 0 1 5 22.928V27a1 1 0 1 1-2 0v-6.5A1.5 1.5 0 0 1 4.5 19h6a1 1 0 1 1 0 2H6.202a11 11 0 0 0 4.307 4.532Z" })));
});
